/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Toast_Storage_Removal_ScheduledInputs */



/**
* | output |
* | --- |
* | "Storage removal scheduled for next billing period." |
*
* @param {Sub_Addons_Toast_Storage_Removal_ScheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_toast_storage_removal_scheduled = /** @type {((inputs?: Sub_Addons_Toast_Storage_Removal_ScheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Toast_Storage_Removal_ScheduledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicherentfernung für den nächsten Abrechnungszeitraum geplant.")
	return /** @type {LocalizedString} */ ("Storage removal scheduled for next billing period.")
});